import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { HiArrowLeftOnRectangle } from 'react-icons/hi2';
import { navigationItems } from '../data/navigationData';

const Sidebar = ({ isOpen, onClose }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <>
      {/* Mobile backdrop */}
      {isOpen && (
        <div
          className="fixed inset-0 bg-gray-600 bg-opacity-50 z-30 md:hidden"
          onClick={onClose}
          aria-hidden="true"
        />
      )}

      {/* Sidebar */}
      <aside
        className={`
          fixed md:static top-0 md:top-auto bottom-0 md:bottom-auto left-0 z-40
          w-64 h-screen md:h-auto bg-white dark:bg-gray-900 border-r border-gray-200 dark:border-gray-700
          transform transition-transform duration-200 ease-in-out
          ${isOpen ? 'translate-x-0' : '-translate-x-full md:translate-x-0'}
          overflow-y-auto
          no-print
        `}
      >
        <nav className="px-4 py-6 space-y-1 pt-20 md:pt-6" aria-label="Main navigation">
          {navigationItems.map((item) => {
            const Icon = item.icon;
            
            return (
              <NavLink
                key={item.id}
                to={item.path}
                onClick={() => {
                  if (window.innerWidth < 768) {
                    onClose();
                  }
                }}
                className={({ isActive }) =>
                  `flex items-center gap-3 px-4 py-3 rounded-lg text-sm font-semibold transition-colors
                  ${isActive
                    ? 'bg-teal-50 dark:bg-teal-900 text-teal-700 dark:text-teal-300'
                    : 'text-gray-900 dark:text-gray-100 hover:bg-gray-50 dark:hover:bg-gray-800 hover:text-teal-700 dark:hover:text-teal-300'
                  }`
                }
              >
                {({ isActive }) => (
                  <>
                    <Icon
                      className={`h-5 w-5 flex-shrink-0 ${isActive ? 'text-teal-600 dark:text-teal-400' : 'text-gray-600 dark:text-gray-400'}`}
                      aria-hidden="true"
                    />
                    <span>{t(item.labelKey)}</span>
                  </>
                )}
              </NavLink>
            );
          })}
        </nav>

        {/* Exit button */}
        <div className="px-4 pb-3 pt-4 mt-2 border-t border-gray-200 dark:border-gray-700">
          <button
            onClick={() => {
              navigate('/');
              if (window.innerWidth < 768) {
                onClose();
              }
            }}
            className="w-full flex items-center justify-center gap-3 px-4 py-3.5 rounded-lg text-sm font-semibold transition-all bg-gradient-to-r from-teal-600 to-teal-500 hover:from-teal-700 hover:to-teal-600 text-white shadow-md hover:shadow-lg transform hover:scale-[1.02]"
          >
            <HiArrowLeftOnRectangle className="h-5 w-5 flex-shrink-0" aria-hidden="true" />
            <span>{t('common.backToWelcome')}</span>
          </button>
        </div>

        {/* Sidebar footer */}
        <div className="px-4 py-4 border-t border-gray-200 dark:border-gray-700">
          <p className="text-xs text-gray-600 dark:text-gray-400 leading-relaxed">
            {t('home.disclaimer')}
          </p>
        </div>
      </aside>
    </>
  );
};

export default Sidebar;
